export default {
      id: "chart-placeholder-usage",
      viewBox: "0 0 16 16",
      url: "assets/" + "sprite.svg#chart-placeholder-usage",
      toString: function () {
        return this.url;
      }
    }